if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shipbob_customers_ui","remotes":[{"alias":"shipbob_design_system","name":"shipbob_design_system","entry":"runtime","shareScope":"default","externalType":"script"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^([13]25|566)$/.test(chunkId)},
		rootOutputDir: "../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"shipbob_design_system":[{"alias":"shipbob_design_system","name":"shipbob_design_system","entry":"runtime","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}